import {Dispatch, createStore} from 'redux';
import {flow, mapValues} from 'lodash';
import {AnyFunction, AnyObject} from 'types';
import {RootState} from './root-state.type';

export const instance = {
  current: createStore((state) => state)
};

export function select<T>(selector: (state: RootState) => T): T;
export function select<T, U>(selector: (state: RootState, params: U) => T, params: U): T;
export function select<T, U>(selector: (state: RootState, params?: U) => T, params?: U): T {
  return selector(instance.current.getState() as RootState, params);
};

export function dispatcher<T extends Record<string, AnyFunction>>(actions: T) {
  return mapValues(actions, (action) => flow(action, (payload) => {
    instance.current.dispatch(payload);
    return payload;
  })) as T;
};
